import { DEFAULT_POWERED_BY } from '@teo/widget-shared';
import { useWidget } from '../context/WidgetContext.js';

/** Footer label when `POWERED_BY_ENABLED` is true. */
export function AiPoweredFooter() {
  const { settings, t } = useWidget();
  const { poweredBy } = settings.content;

  if (!poweredBy.enabled) return null;

  const label = poweredBy.text.trim() || t.aiPoweredLabel;
  const url = poweredBy.url.trim() || DEFAULT_POWERED_BY.url;

  return (
    <p className="teo-ai-label">
      {url ? (
        <a href={url} target="_blank" rel="noopener noreferrer">
          {label}
        </a>
      ) : (
        label
      )}
    </p>
  );
}
